import styled from 'styled-components';
import { fade } from '@material-ui/core';

export const CountCard = styled.div`
    ${({ theme }) => `
        padding: ${theme.spacing(1)}px ${theme.spacing(1.5)}px;
        border-radius: ${theme.shape.borderRadius}px;
        background-color: ${fade(theme.palette.additional.blue, 0.16)};
    `}
    display: grid;
    grid-template-columns: 49px auto;
    align-items: center;
    gap: 0 6px;
`;

export const CountCircle = styled.div`
    color: ${({ theme }) => theme.palette.additional.blue};
    background-color: #fff;
    border-radius: 50%;
    width: 49px;
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
